import { createRoot, type Root } from 'react-dom/client';
import type { ReactNode } from 'react';

/** Document-local lifecycle retained by Vite across entry-module reevaluation. */
export interface ApplicationMountState {
  root?: Root;
  generation?: number;
}

/** Reuse one React root, and reject results from an older asynchronous bootstrap. */
export function createApplicationRenderer(container: HTMLElement, state: ApplicationMountState) {
  const generation = (state.generation ?? 0) + 1;
  state.generation = generation;
  return (content: ReactNode): boolean => {
    if (state.generation !== generation) return false;
    state.root ??= createRoot(container);
    state.root.render(content);
    return true;
  };
}
